// extracted by mini-css-extract-plugin
export default {"content":"Home_content__aDyUb","author":"Home_author__sJz1E","box":"Home_box__Ga8O5"};